const handleCustomSelect = () => {
  const $container = $('.js-form-select');
  const $trigger = $container.find('.form__select-trigger');
  const $selectPrimary = $container.find('.form__select-primary');
  const $menu = $container.find('.form__select-menu');
  const $menuItem = $menu.find('.form__select-menu-item');

  $trigger.on('click', function(event) {
    $menu
      .slideToggle();

    $container
      .toggleClass('is-open');

    event.preventDefault();
  });

  $menuItem.on('click', function(event) {
    const $this = $(this);
    const $customerTagsField = $this.closest('.form').find('input[name="contact[tags]"]');
    const $customerTagsValue = 'newsletter,' + $this.text();

    $selectPrimary
      .val($this.text());

    $trigger
      .find('.form__select-trigger-content')
      .text($this.text());

    $menu
      .slideUp();

    $container
      .removeClass('is-open');

    $customerTagsField.val($customerTagsValue);

    event.preventDefault();
  });
}

$(document).ready(function() {
  handleCustomSelect();
});
